import { RadioGroup } from '@heroui/react';
import {
  PaymentTypeRadio,
  PaymentTypeRadioProps,
} from '@ui/checkout/payment-type-radio';

export type PaymentTypesProps = {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  items?: PaymentTypeRadioProps[];
};

export const PaymentTypes = ({
  value,
  onChange,
  label,
  items = [],
}: PaymentTypesProps) => {
  return (
    <RadioGroup
      label={label}
      value={value}
      onValueChange={onChange}
      classNames={{
        base: 'gap-6 mt-4',
        wrapper: 'flex flex-col gap-3',
        label: 'text-[#222223] font-semibold text-lg',
      }}
    >
      {items?.map((item) => <PaymentTypeRadio key={item.value} {...item} />)}
    </RadioGroup>
  );
};
